__turbopack_context__.v({
  "badgeRow": "welcome-card-module__sYlUGG__badgeRow",
  "ctaDock": "welcome-card-module__sYlUGG__ctaDock",
  "langToggle": "welcome-card-module__sYlUGG__langToggle",
  "scrollPane": "welcome-card-module__sYlUGG__scrollPane",
  "stickyMedia": "welcome-card-module__sYlUGG__stickyMedia",
});
